import './index.less';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import Badge from 'reactstrap/es/Badge';
import { getFileUrl } from '../../../Api/Files';

function ImageWithFallback ({ src, fallbackComponent, ...otherProps }) {
	const [isError, setError] = useState(false);
	if (isError) return fallbackComponent;
	return <img src={src} {...otherProps} onError={() => setError(true)} />;
}

export function CompactBadgeUser ({ avatar, fullName = '', email = '', registered, _id, noavatar, type, deleted }) {
	let [firstName] = fullName.split(' ');
	const firstNameChar = firstName[0] || email[0];
	if (type === 'legal') firstName = fullName;
	if (firstName.startsWith('ООО')) firstName = fullName;

	return (
		<div className="badge_user compact">
			{!noavatar && (
				<div className="image">
					{avatar ? (
						<ImageWithFallback
							src={getFileUrl(avatar)}
							alt=""
							fallbackComponent={<div className="name"><strong>{firstNameChar}</strong></div>}
						/>
					) : <div className="name"><strong>{firstNameChar}</strong></div>}
				</div>
			)}
			<div className="badge_user-content">
				{deleted && <Badge color="danger">Deleted</Badge>}{fullName && <div className="name"><strong>{firstName}</strong></div>}
				<div className="info">
					{registered && (
						<Link to={`/users/${_id}`}>{email}</Link>
					)}
					{!registered && (
						email
					)}
					{type === 'legal' ? 'Юридическое лицо' : null}
				</div>
			</div>
		</div>
	);
}

export function BadgeUser ({ avatar, email, registered, _id, phone, secondName, firstName, patronymic, noavatar }) {
	if (!firstName) return null;
	const fullName = [secondName, firstName, patronymic].filter(Boolean)
		.join(' ');
	return (
		<div className="badge_user info">
			{!noavatar && (
				<div className="image">
					{avatar ? <ImageWithFallback src={getFileUrl(avatar)} alt="" fallbackComponent={<div className="name"><strong>{fullName[0]}</strong></div>} /> : <div className="name"><strong>{fullName[0]}</strong></div>}
				</div>
			)}
			<div className="badge_user-content ">
				<div className="name"><strong>{fullName}</strong></div>
				<div className="info">
					{registered && (
						<Link to={`/users/${_id}`}>Перейти в профиль</Link>
					)}
					<ul className="info_list">
						<li>{phone}</li>
						<li>{email}</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
